import { Injectable } from '@angular/core';
import { ActivatedRouterStateSnapshot, PageType, ProductSearchPage, RoutingService } from '@spartacus/core';
import { ProductFacetService, ProductListComponentService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root'
})
export class EKProductFacetService extends ProductFacetService {

  constructor(
    protected routing: RoutingService,
    protected productListComponentService: ProductListComponentService
  ) {
    super(routing, productListComponentService)
  }
  /**
 * Filters the current result by verifying if the result is related to the page.
 * This is done to avoid a combination of the next page and the current search results.
 */
  filterForPage(
    state: ActivatedRouterStateSnapshot,
    page: ProductSearchPage
  ): boolean {
    if (!page.currentQuery?.query?.value) {
      return false;
    }
    if (state.context.type === PageType.CATEGORY_PAGE) {
      return (
        page.currentQuery.query.value.indexOf(
          `allCategories:${state.context.id}`
        ) > -1
      );
    }
    if (
      state.context.type === PageType.CONTENT_PAGE &&
      state.context.id === 'search'
    ) {
      return page.freeTextSearch === state.params.query.split(':')[0];
    }

    if (state.context.type === PageType.CONTENT_PAGE && state.context.id == '__HOMEPAGE__') {
      return true;
    } else {
      return false;
    }

  }

}



